import K from "./constants";
import restHelpers from "../helpers/restHelper";

const get = () => restHelpers.withBearer.get(`${K.API_URL}/api/v1/services`, {});
const getActiveInsurancePolicy = (plate) => restHelpers.withBearer.get(`${K.API_URL}/api/v1/services/${plate}/active-insurance-policy`, {});

export default {
  get,
  getActiveInsurancePolicy
};



// WEBPACK FOOTER //
// ./src/services/catalog.js